import { render, staticRenderFns } from "./teamWorker.vue?vue&type=template&id=647d975e&scoped=true&"
import script from "./teamWorker.vue?vue&type=script&lang=js&"
export * from "./teamWorker.vue?vue&type=script&lang=js&"
import style0 from "./teamWorker.vue?vue&type=style&index=0&id=647d975e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647d975e",
  null
  
)

export default component.exports